var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"typing-test-basic-item"}},[_c('div',{class:['letter-wrapper', _vm.letterStyle]},[_vm._v(_vm._s(_vm.letter))]),_c('div',{class:['letter-wrapper', 'key-in', _vm.inputLetterStyle]},[_vm._v(_vm._s(_vm.inputLetter))])])}
var staticRenderFns = []

export { render, staticRenderFns }